import { render, staticRenderFns } from "./ti8.vue?vue&type=template&id=eef527a0&scoped=true&"
import script from "./ti8.vue?vue&type=script&lang=js&"
export * from "./ti8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef527a0",
  null
  
)

export default component.exports